import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, className, ...rest }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: EASE }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ kicker, title, description, light = false, compact = false }) {
  const testId = kicker.toLowerCase().replace(/[^a-z0-9]+/g, "-");
  return (
    <Reveal className="max-w-2xl">
      <p data-testid={`${testId}-heading`} className={`text-xs font-semibold uppercase tracking-[0.3em] ${light ? "text-lavender-300" : "text-lavender-600"}`}>
        {kicker}
      </p>
      <h2 data-testid={`${testId}-title`} className={`font-serif tracking-tight ${compact ? "mt-2 text-2xl sm:text-3xl" : "mt-4 text-3xl sm:text-4xl lg:text-5xl"} ${light ? "text-white" : "text-stone-900"}`}>
        {title}
      </h2>
      {description && (
        <p data-testid={`${testId}-description`} className={`leading-relaxed ${compact ? "mt-2 text-sm sm:text-base" : "mt-5 text-base md:text-lg"} ${light ? "text-lavender-200" : "text-stone-600"}`}>
          {description}
        </p>
      )}
    </Reveal>
  );
}
